export class RestoreSecurityGroupsSecurityGroupsInner {
    'name';
    'id';
    'vpc';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "vpc",
            "baseName": "vpc",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RestoreSecurityGroupsSecurityGroupsInner.attributeTypeMap;
    }
    constructor() {
    }
}
